<template>
  <generic-update :model="model">
    <template v-slot:form="{ error, fetch, item, loading, submit }">
      <person-role-form
        :with-data="item"
        :error="error"
        :loading="loading"
        @submit="submit"
        @reset="fetch"
      />
    </template>
  </generic-update>
</template>

<script>
import PersonRoleForm from "./Form"
import model from "./model"

export default {
  components: { PersonRoleForm },
  data() {
    return {
      model,
      localData: {},
    }
  },
}
</script>
